// Colores por aspecto compartidos entre todos los visuales de PlanDocument/
// (Rueda, Pilares, Mosaico, Ruta, Gantt, Carriles, Hitos) — mismos 7 hex que
// ASPECT_COLOR en StrategicPlan.js, para que el color de cada aspecto sea el
// mismo en toda la app.
export const ASPECT_COLOR = {
  energy: "#1A3562",
  water: "#5E89B4",
  waste: "#A8C4DC",
  effluent: "#7BA3C8",
  fuels: "#2D5F8A",
  health_safety: "#8A5A08",
  social: "#6B4FA0",
};

// Aclara un color mezclándolo con blanco (0-1) — puerto literal de mixHex()
// del mockup de referencia.
export function mixHex(hex, white) {
  const n = parseInt(hex.replace("#", ""), 16);
  const r = (n >> 16) & 255, g = (n >> 8) & 255, b = n & 255;
  const f = (x) => Math.round(x + (255 - x) * white);
  return `rgb(${f(r)},${f(g)},${f(b)})`;
}
